<script setup lang="ts">
import { computed } from 'vue';
import type { PageName } from '@/api/tracking';
import SurveyContentRenderer from '@/components/survey/generate-content/survey-content-renderer.vue';
import type { AdpDocument, UserDocument } from '@/types';
import { sanitize } from '@/utils/sanitize';
import { markdownToHtmlOptions } from '@/utils/survey/common';
import { parseSurveyNode } from '@/utils/survey/domParser';

const props = defineProps<{
  message: string;
  sources: Array<AdpDocument | UserDocument>;
  pageName: PageName;
}>();

const parts = computed(() => {
  const sanitizedMessage = sanitize(props.message, markdownToHtmlOptions);
  const doc = new DOMParser().parseFromString(sanitizedMessage, 'text/html');

  return parseSurveyNode(doc.body, false, props.sources).parts;
});
</script>

<template>
  <div class="deep-process-message-content">
    <SurveyContentRenderer
      :content-parts="parts"
      :enable-animation="false"
      :status="{
        isInProgress: false,
        isNoHit: false,
        isError: false,
        progressMessage: '',
      }"
      feature="survey"
      :page-name="props.pageName"
    />
  </div>
</template>

<style scoped lang="scss">
.deep-process-message-content {
  display: block;
  width: 100%;
  white-space: pre-wrap;
}
</style>
